import { useContext } from "react";

import { AuthContext } from "@/features/auth/components/AuthContext";

/**
 * Custom hook to access authentication context
 *
 * @returns Authentication context with user data and auth methods
 * @throws Error if used outside of AuthProvider
 *
 * @example
 * ```typescript
 * const { currentUser, login, logout } = useAuth();
 * ```
 */
export function useAuth() {
  const context = useContext(AuthContext);

  if (context === undefined) {
    throw new Error("useAuth must be used within an AuthProvider");
  }

  return context;
}
